import { Controller } from "stimulus";

export default class extends Controller {

  connect(){
    if ($(".js-report-card-select").is("*")) {
      var first_form_id = $(".js-report-card-select").val();

      $("#new-report-card-form").find(".js-report-card-form").find('input, select, textarea, button').not('.trix-input').prop('disabled', true);
      $("#report-card-" + first_form_id).find('input, select, textarea, button, .trix-input').not('.trix-input').prop('disabled', false);
      $('.selectpicker').selectpicker('refresh');

      $(".js-report-card-select").on("change", (e) => {
        var form_id = $(e.target).val();
        var target_form = $("#report-card-" + form_id);
        var visible_form = $(e.target).parents('#new-report-card-form').find(".js-report-card-form:visible");

        visible_form.slideUp('fast', function() {
          $("#new-report-card-form").find(".js-report-card-form").find('input, select, textarea, button').not('.trix-input').prop('disabled', true);
          target_form.find('input, select, textarea, button').not('.trix-input').prop('disabled', false);
          target_form.slideDown('fast');
          $('.selectpicker').selectpicker('refresh');
        });
      });
    }

    if ($('.js-report-card-client-select').is('*')) {
      var controller = this;
      controller.updateReportCardPetFields();

      $(".js-report-card-client-select").on("change", () => {
        controller.updateReportCardPetFields();
      });
    }

    $('body').on('click', '.js-report-card-pets-edit-card .btn', function(){
      var button = $(this);

      setTimeout(function(){
        if (button.hasClass('active')){
          button.find('input').prop('disabled', false);

          if (button.find('.destroy-check')) {
            button.find('.destroy-check').val(false);
          }
        } else {
          if (button.find('.destroy-check')) {
            button.find('.destroy-check').val(true);
          } else {
            button.find('input').prop('disabled', true);
          }
        }
      }, 200);
    });
  }

  updateReportCardPetFields() {
    var client_id = $("select.js-report-card-client-select").val();

    if (client_id) {
      var pet_fields = $('.js-report-card-pets');

      pet_fields.find('input').prop('disabled', true);
      pet_fields.find('label').hide();
      pet_fields.find("label[data-client='"+client_id+"']").show();
      pet_fields.find("label[data-client='"+client_id+"'] input").prop('disabled', false);
      pet_fields.find("label[data-client='"+client_id+"'] input").prop('checked', true);
      pet_fields.find("label[data-client='"+client_id+"']").addClass('active');
    }
  }

}